<template>
  <div>
    <b-modal
        :id="modalUUid"
        :ref="modalUUid"
        title="Add goodwill credit"
        :hide-footer="true"
    >
      <BaseForm
          ref="main_form"
          :settings="goodwillCreditFormSettings"
          @success="successAddedCredit"
          @cancel="$bvModal.hide(modalUUid)"
          v-slot="{ save, cancel }"
      >
        <b-row class="mb-1">
          <b-col cols="3">Type</b-col>
          <b-col cols="6">
            <FormElement
                ref="creditType"
                :elementSettings="goodwillCreditFormSettings.formElements.type"
                :formSettings="goodwillCreditFormSettings"
            />
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">Publisher Payout</b-col>
          <b-col cols="6">
            <div class="d-flex align-items-center" style="gap: 5px;">
              <FormElement
                  ref="publisherPayout"
                  :elementSettings="goodwillCreditFormSettings.formElements.publisher_payout"
                  :formSettings="goodwillCreditFormSettings"
              />
              $
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">Exchange Rate</b-col>
          <b-col cols="9">
            $1 USD = {{ exchangeRate }} {{ currencyName }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">User Reward</b-col>
          <b-col cols="6">
            <div class="d-flex align-items-center" style="gap: 5px;">
              <FormElement
                  ref="userReward"
                  :elementSettings="goodwillCreditFormSettings.formElements.user_reward"
                  :formSettings="goodwillCreditFormSettings"
              />
              {{ currencyName }}
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col cols="3">Reference</b-col>
          <b-col cols="9">
            <FormElement
                ref="reference"
                :elementSettings="goodwillCreditFormSettings.formElements.reference"
                :formSettings="goodwillCreditFormSettings"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button variant="primary" @click="save()" class="mr-1">
              Save
            </b-button>
            <b-button variant="warning" @click="cancel()"
            >Cancel</b-button
            >
          </b-col>
        </b-row>
      </BaseForm>
    </b-modal>
  </div>
</template>

<script>
export default {
  props:{
    userId: {
      required: true,
      type: Number
    },
    exchangeRate: {
      required: true
    },
    currencyName: {
      type: String,
      default: 'Points'
    },
    maxCreditAmount: {
      type: Number,
      default: 10
    }
  },
  data () {
    const _this = this

    return {
      modalUUid: `user-goodwill-credit-modal${ this.userId }`,
      goodwillCreditFormSettings: {
        addUrl: `/api/user/${  this.userId  }/goodwill-credit`,
        primaryKey: 'id',
        formElements: {
          type: {
            type: 'select',
            defaultValue: 'surveys',
            rules: ['required'],
            post_param: 'type',
            value: 'surveys',
            data: [
              { value: 'surveys', text: 'Surveys' },
              { value: 'offers', text: 'Offers' }
            ],
            errorClass: 'input-error',
            errorMessage: 'Type is required!',
            isValidated: false,
            isError: false
          },
          publisher_payout: {
            type: 'input',
            sub_type: 'number',
            defaultValue: 0,
            rules: ['required'],
            value: 0,
            errorClass: 'input-error',
            errorMessage: 'Publisher Payout is invalid!',
            isValidated: false,
            isError: false,
            post_param: 'payout',
            event: {
              input ($event, elementSettings, formSettings) {
                const userReward = elementSettings.value * _this.exchangeRate
                formSettings.formElements.user_reward.value = (userReward % 1 === 0) ? userReward.toFixed(0) : userReward.toFixed(2)
              }
            },
            validate (elementSettings) {
              return elementSettings.value <= _this.maxCreditAmount
            }
          },
          user_reward: {
            type: 'input',
            sub_type: 'number',
            defaultValue: 0,
            rules: ['required'],
            value: 0,
            errorClass: 'input-error',
            errorMessage: 'User Reward is invalid!',
            isValidated: false,
            isError: false,
            post_param: 'user_reward',
            event: {
              input ($event, elementSettings, formSettings) {
                const pbulisherPayout = elementSettings.value / _this.exchangeRate
                formSettings.formElements.publisher_payout.value = (pbulisherPayout % 1 === 0) ? pbulisherPayout.toFixed(0) : pbulisherPayout.toFixed(2)
              }
            }
          },
          reference: {
            type: 'input',
            defaultValue: '',
            rules: ['required'],
            post_param: 'reference',
            value: '',
            errorClass: 'input-error',
            errorMessage: 'Reference is required!',
            isValidated: false,
            place_holder: 'Reference',
            isError: false
          }
        },
        vueContainer: this
      }
    }
  },
  watch: {
    // The Select element only binds v-model (no event hook), so we watch its
    // value here. On change we ask the parent (which owns app_id + the fetch)
    // to re-fetch the exchange rate for the chosen type via the `type-changed`
    // event. No offer_id is sent — OP-496 v1 is app-level offers (no picker).
    'goodwillCreditFormSettings.formElements.type.value' (newType) {
      this.$emit('type-changed', { type: newType, offer_id: null })
    },
    // When the parent updates the exchangeRate prop after a re-fetch, recompute
    // the displayed user_reward from the current publisher payout.
    exchangeRate () {
      this.recalculateUserReward()
    }
  },
  methods: {
    recalculateUserReward () {
      const payout = this.goodwillCreditFormSettings.formElements.publisher_payout.value
      const userReward = payout * this.exchangeRate
      this.goodwillCreditFormSettings.formElements.user_reward.value = (userReward % 1 === 0) ? userReward.toFixed(0) : userReward.toFixed(2)
    },
    showForm () {
      this.$bvModal.show(this.modalUUid)

      this.$nextTick(() => {
        this.getFormVue().clearForm()
      })
    },
    successAddedCredit (data) {
      this.$emit('added', data)
      this.$bvModal.hide(this.modalUUid)
    },
    getFormVue () {
      return this.$refs.main_form
    }
  }
}
</script>

<style>
</style>
